module.exports = __webpack_public_path__ + "static/media/bannedWords.1ba0ee58.txt";